// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__oCE2T","logoContainer":"Home_logoContainer__qPf+e","mainButtons":"Home_mainButtons__Mt6SI"};